import {
  POST_GRAFANA_ENABLE_DISABLE_ALERTS,
  POST_GRAFANA_ENABLE_DISABLE_ALERTS_FAIL,
  POST_GRAFANA_ENABLE_DISABLE_ALERTS_SUCCESS,
  POST_GRAFANA_CREATE_RESOURCE_ALERTS,
  POST_GRAFANA_CREATE_RESOURCE_ALERTS_FAIL,
  POST_GRAFANA_CREATE_RESOURCE_ALERTS_SUCCESS,
  POST_GRAFANA_CREATE_DYNAMIC_ALERT,
  POST_GRAFANA_CREATE_DYNAMIC_ALERT_FAIL,
  POST_GRAFANA_CREATE_DYNAMIC_ALERT_SUCCESS,
  GET_GRAFANA_ALERTS,
  GET_GRAFANA_ALERTS_FAIL,
  GET_GRAFANA_ALERTS_SUCCESS, 
  GET_GRAFANA_DYNAMIC_ALERTS,
  GET_GRAFANA_DYNAMIC_ALERTS_FAIL,
  GET_GRAFANA_DYNAMIC_ALERTS_SUCCESS,
  GET_GRAFANA_MISSING_DYNAMIC_ALERTS,
  GET_GRAFANA_MISSING_DYNAMIC_ALERTS_FAIL,
  GET_GRAFANA_MISSING_DYNAMIC_ALERTS_SUCCESS,
  GET_GRAFANA_DEFAULT_THRESHOLD,
  GET_GRAFANA_DEFAULT_THRESHOLD_FAIL,
  GET_GRAFANA_DEFAULT_THRESHOLD_SUCCESS,
  GET_GRAFANA_RESOURCE_BY_ID,
  GET_GRAFANA_RESOURCE_BY_ID_FAIL,
  GET_GRAFANA_RESOURCE_BY_ID_SUCCESS,
  GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
  GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
  GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
  POST_GRAFANA_ALERT,
  POST_GRAFANA_ALERT_FAIL,
  POST_GRAFANA_ALERT_SUCCESS,
  GET_GRAFANA_RESCAN,
  GET_GRAFANA_RESCAN_FAIL,
  GET_GRAFANA_RESCAN_SUCCESS,
  GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID,
  GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
  GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
  GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
  POST_GRAFANA_SERVICE_MAPPING,
  POST_GRAFANA_SERVICE_MAPPING_FAIL,
  POST_GRAFANA_SERVICE_MAPPING_SUCCESS,
  POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  GET_GRAFANA_RESOURCES,
  GET_GRAFANA_RESOURCES_FAIL,
  GET_GRAFANA_RESOURCES_SUCCESS,
  GET_ALL_ORG_GRAFANA_RESOURCE_TYPES,
  GET_ALL_ORG_GRAFANA_RESOURCE_TYPES_FAIL,
  GET_ALL_ORG_GRAFANA_RESOURCE_TYPES_SUCCESS,
  GET_RESCAN_STATUS_GRAFANA,
  GET_RESCAN_STATUS_GRAFANA_FAIL,
  GET_RESCAN_STATUS_GRAFANA_SUCCESS,
  POST_UPDATE_GRAFANA_THRESHOLD,
  POST_UPDATE_GRAFANA_THRESHOLD_FAIL,
  POST_UPDATE_GRAFANA_THRESHOLD_SUCCESS,
  POST_ENABLE_DISABLE_GRAFANA_THRESHOLD,
  POST_ENABLE_DISABLE_GRAFANA_THRESHOLD_FAIL,
  POST_ENABLE_DISABLE_GRAFANA_THRESHOLD_SUCCESS,
  GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_GRAFANA_THRESHOLD,
  GET_GRAFANA_THRESHOLD_FAIL,
  GET_GRAFANA_THRESHOLD_SUCCESS,
    GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS,
    GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS_FAIL,
    GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
    GET_GRAFANA_ALL_EXTERNAL_SERVICES,
    GET_GRAFANA_ALL_EXTERNAL_SERVICES_FAIL,
    GET_GRAFANA_ALL_EXTERNAL_SERVICES_SUCCESS,
    GET_GRAFANA_NON_KEY_TRANSACTIONS,
    GET_GRAFANA_NON_KEY_TRANSACTIONS_FAIL,
    GET_GRAFANA_NON_KEY_TRANSACTIONS_SUCCESS,
    POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
    POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL,
    POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS,

 } from "./actionTypes";


export const postEnableDisableGrafanaThreshold = (data) => ({
  type: POST_ENABLE_DISABLE_GRAFANA_THRESHOLD,
  payload: data,
})

export const postEnableDisableGrafanaThresholdFail = error => ({
  type: POST_ENABLE_DISABLE_GRAFANA_THRESHOLD_FAIL,
  payload: error,
})

export const postEnableDisableGrafanaThresholdSuccess = (response) => ({
  type: POST_ENABLE_DISABLE_GRAFANA_THRESHOLD_SUCCESS,
  payload: response,
})

export const postUpdateGrafanaThreshold = (data) => ({
  type: POST_UPDATE_GRAFANA_THRESHOLD,
  payload: data
})

export const postUpdateGrafanaThresholdFail = error => ({
  type: POST_UPDATE_GRAFANA_THRESHOLD_FAIL,
  payload: error
})

export const postUpdateGrafanaThresholdSuccess = (response) => ({
  type: POST_UPDATE_GRAFANA_THRESHOLD_SUCCESS,
  payload: response
})

export const getRescanStatusGrafana = (data) => ({
  type: GET_RESCAN_STATUS_GRAFANA,
  payload: data
})

export const getRescanStatusGrafanaFail = error => ({
  type: GET_RESCAN_STATUS_GRAFANA_FAIL,
  payload: error
})

export const getRescanStatusGrafanaSuccess = (grafana_rescan_status) => ({
  type: GET_RESCAN_STATUS_GRAFANA_SUCCESS,
  payload: grafana_rescan_status
})

export const getGrafanaRescan = () => ({
  type: GET_GRAFANA_RESCAN,
  payload: []
})

export const getGrafanaRescanFail = error => ({
  type: GET_GRAFANA_RESCAN_FAIL,
  payload: error
})

export const getGrafanaRescanSuccess = (data) => ({
  type: GET_GRAFANA_RESCAN_SUCCESS,
  payload: data
})

export const getGrafanaResources = () => ({
  type: GET_GRAFANA_RESOURCES,
})

export const getGrafanaResourcesFail = error => ({
  type: GET_GRAFANA_RESOURCES_FAIL,
  payload: error
})

export const getGrafanaResourcesSuccess = grafana_resources => ({
  type: GET_GRAFANA_RESOURCES_SUCCESS,
  payload: grafana_resources
})

export const getGrafanaMissingAlertByResourceId = (monitored_resource_id) => ({
  type: GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID,
  payload: monitored_resource_id
})

export const getGrafanaMissingAlertByResourceIdFail = error => ({
  type: GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID_FAIL,
  payload: error
})

export const getGrafanaMissingAlertsByResourceIdSuccess = (response) => ({
  type: GET_GRAFANA_MISSING_ALERT_BY_RESOURCE_ID_SUCCESS,
  payload: response
})

export const getGrafanaAllResourceAlertsPage = (data) => ({
  type: GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE,
  payload: data
})

export const getGrafanaAllResourceAlertsPageFail = error => ({
  type: GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  payload: error
})

export const getGrafanaAllResourceAlertsPageSuccess = (grafana_all_resource_alerts) => ({
  type: GET_GRAFANA_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  payload: grafana_all_resource_alerts
})

export const getGrafanaAllResourceAlertsCountPage = (data) => ({
  type: GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE,
  payload: data
})

export const getGrafanaAllResourceAlertsCountPageFail = error => ({
  type: GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE_FAIL,
  payload: error
})

export const getGrafanaAllResourceAlertsCountPageSuccess = (grafana_all_resource_alerts_count) => ({
  type: GET_GRAFANA_ALL_RESOURCE_ALERTS_COUNT_PAGE_SUCCESS,
  payload: grafana_all_resource_alerts_count
})

export const postGrafanaAlert = (data) => ({
  type: POST_GRAFANA_ALERT,
  payload: data
})

export const postGrafanaAlertFail = error => ({
  type: POST_GRAFANA_ALERT_FAIL,
  payload: error
})

export const postGrafanaAlertsSuccess = (response) => ({
    type: POST_GRAFANA_ALERT_SUCCESS,
    payload: response
})

export const postGrafanaServiceMapping = (data) => ({
  type: POST_GRAFANA_SERVICE_MAPPING,
  payload: data
})

export const postGrafanaServiceMappingFail = error => ({
  type: POST_GRAFANA_SERVICE_MAPPING_FAIL,
  payload: error
})

export const postGrafanaServiceMappingSuccess = (response) => ({
  type: POST_GRAFANA_SERVICE_MAPPING_SUCCESS,
  payload: response
})

export const postGrafanaResourceOpsGenieTeamMapping = (data) => ({
  type: POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING,
  payload: data
})

export const postGrafanaResourceOpsGenieTeamMappingFail = error => ({
  type: POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  payload: error
})

export const postGrafanaResourceOpsGenieTeamMappingSuccess = (response) => ({
  type: POST_GRAFANA_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  payload: response
})

export const postGrafanaResourcePagerdutyMapping = (data) => ({
  type: POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  payload: data
})

export const postGrafanaResourcePagerdutyMappingFail = error => ({
  type: POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  payload: error
})

export const postGrafanaResourcePagerdutyMappingSuccess = (response) => ({
  type: POST_GRAFANA_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  payload: response
})

export const getAllOrgGrafanaResourceTypes = () => ({
  type: GET_ALL_ORG_GRAFANA_RESOURCE_TYPES
})

export const getAllOrgGrafanaResourceTypesFail = error => ({
  type: GET_ALL_ORG_GRAFANA_RESOURCE_TYPES_FAIL,
  payload: error
})

export const getAllOrgGrafanaResourceTypesSuccess = orgGrafanaResourceTypes => ({
  type: GET_ALL_ORG_GRAFANA_RESOURCE_TYPES_SUCCESS,
  payload: orgGrafanaResourceTypes
})


 export const postGrafanaEnableDisableAlerts = (data) => ({
    type: POST_GRAFANA_ENABLE_DISABLE_ALERTS,
    payload: { data }
 })

 export const postGrafanaEnableDisableAlertsFail = error =>({
    type: POST_GRAFANA_ENABLE_DISABLE_ALERTS_FAIL,
    payload: error
 })

 export const postGrafanaEnableDisableAlertsSuccess = (response) => ({
    type: POST_GRAFANA_ENABLE_DISABLE_ALERTS_SUCCESS,
    payload: response
 })

 export const postGrafanaCreateResourceAlerts = (data) => ({
  type: POST_GRAFANA_CREATE_RESOURCE_ALERTS,
  payload: { data }
 })

 export const postGrafanaCreateResourceAlertsFail = error => ({
  type: POST_GRAFANA_CREATE_RESOURCE_ALERTS_FAIL,
  payload: error
 })

 export const postGrafanaCreateResourceAlertsSuccess = (response) => ({
  type: POST_GRAFANA_CREATE_RESOURCE_ALERTS_SUCCESS,
  payload: response
 })

 export const postGrafanaCreateDynamicAlert = (data) =>({
  type: POST_GRAFANA_CREATE_DYNAMIC_ALERT,
  payload: { data }
 })

export const postGrafanaCreateDynamicAlertSuccess = (response) => ({
  type: POST_GRAFANA_CREATE_DYNAMIC_ALERT_SUCCESS,
  payload: response
})

export const postGrafanaCreateDynamicAlertFail = error => ({
  type: POST_GRAFANA_CREATE_DYNAMIC_ALERT_FAIL,
  payload: error
})

export const getGrafanaAlerts = (monitored_resource_id) => (
    {
      type: GET_GRAFANA_ALERTS,
      payload: monitored_resource_id
    }
)

export const getGrafanaAlertsSuccess = grafana_alerts => ({
  type: GET_GRAFANA_ALERTS_SUCCESS,
  payload: grafana_alerts
})

export const getGrafanaAlertsFail = error => ({
  type: GET_GRAFANA_ALERTS_FAIL,
  payload: error
})

export const getGrafanaDynamicAlerts = (monitored_resource_id) => ({
  type: GET_GRAFANA_DYNAMIC_ALERTS,
  payload: monitored_resource_id
})

export const getGrafanaDynamicAlertsSuccess = grafana_dynamic_alerts => ({
  type: GET_GRAFANA_DYNAMIC_ALERTS_SUCCESS,
  payload: grafana_dynamic_alerts
})

export const getGrafanaDynamicAlertsFail = error => ({
  type: GET_GRAFANA_DYNAMIC_ALERTS_FAIL,
  payload: error
})

export const getGrafanaMissingDynamicAlerts = (monitored_resource_id) => ({
  type: GET_GRAFANA_MISSING_DYNAMIC_ALERTS,
  payload: monitored_resource_id
})

export const getGrafanaMissingDynamicAlertsFail = error => ({
  type: GET_GRAFANA_MISSING_DYNAMIC_ALERTS_FAIL,
  payload: error
})

export const getGrafanaMissingDynamicAlertsSuccess = grafana_missing_dynamic_alerts => ({
  type: GET_GRAFANA_MISSING_DYNAMIC_ALERTS_SUCCESS,
  payload: grafana_missing_dynamic_alerts
})

export const getGrafanaDefaultThreshold = threshold_type => ({
  type: GET_GRAFANA_DEFAULT_THRESHOLD,
  payload: threshold_type
})

export const getGrafanaDefaultThresholdFail = error => ({
  type: GET_GRAFANA_DEFAULT_THRESHOLD_FAIL,
  payload: error
})

export const getGrafanaDefaultThresholdSuccess = defaultThreshold => ({
  type: GET_GRAFANA_DEFAULT_THRESHOLD_SUCCESS,
  payload: defaultThreshold
})

export const getGrafanaThreshold = metric_id => ({
  type: GET_GRAFANA_THRESHOLD,
  payload: metric_id
})

export const getGrafanaThresholdFail = error => ({
  type: GET_GRAFANA_THRESHOLD_FAIL,
  payload: error
})

export const getGrafanaThresholdSuccess = appDynamicsThreshold => ({
  type: GET_GRAFANA_THRESHOLD_SUCCESS,
  payload: appDynamicsThreshold
})

export const getGrafanaResourceById = monitored_resource_id => ({
  type: GET_GRAFANA_RESOURCE_BY_ID,
  payload: monitored_resource_id
})

export const getGrafanaResourceByIdSuccess = grafana_resource => ({
  type: GET_GRAFANA_RESOURCE_BY_ID_SUCCESS,
  payload: grafana_resource
})

export const getGrafanaResourceByIdFail = error => ({
  type: GET_GRAFANA_RESOURCE_BY_ID_FAIL,
  payload: error
})

export const getGrafanaResourcesDefaultThresholdById = monitored_resource_id => (
    {
    type: GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID,
    payload: monitored_resource_id
  }
)

export const getGrafanaResourcesDefaultThresholdByIdSuccess = grafana_resource_default_threshold => ({
  type: GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID_SUCCESS,
  payload: grafana_resource_default_threshold
})

export const getGrafanaResourcesDefaultThresholdByIdFail = error => ({
  type: GET_GRAFANA_RESOURCE_DEFAULT_THRESHOLD_BY_ID_FAIL,
  payload: error
})

export const getMissingGrafanaAlertsByResourceID = data => ({
  type: GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID,
  payload: data
})

export const getMissingGrafanaAlertsByResourceIDSuccess = grafana_resource_missing_alerts => ({
  type: GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  payload: grafana_resource_missing_alerts,
})

export const getMissingGrafanaAlertsByResourceIDFail = error => ({
  type: GET_GRAFANA_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  payload: error,
})

export const getGrafanaAllBusinessTransactions = (data) => ({
  type: GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS,
  payload: data
})

export const getGrafanaAllBusinessTransactionsFail = error => ({
  type: GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS_FAIL,
  payload: error
})

export const getGrafanaAllBusinessTransactionsSuccess = (grafana_all_resource_alerts) => ({
  type: GET_GRAFANA_ALL_BUSINESS_TRANSACTIONS_SUCCESS,
  payload: grafana_all_resource_alerts
})


export const getGrafanaAllExternalServicesPage = (data) => ({
  type: GET_GRAFANA_ALL_EXTERNAL_SERVICES,
  payload: data
})

export const getGrafanaAllExternalServicesPageFail = error => ({
  type: GET_GRAFANA_ALL_EXTERNAL_SERVICES_FAIL,
  payload: error
})

export const getGrafanaAllExternalServicesPageSuccess = (grafana_all_resource_alerts) => ({
  type: GET_GRAFANA_ALL_EXTERNAL_SERVICES_SUCCESS,
  payload: grafana_all_resource_alerts
})

export const getGrafanaNonKeyTransactions = (page_filters) => ({
    type: GET_GRAFANA_NON_KEY_TRANSACTIONS,
    payload: page_filters
})

export const getGrafanaNonKeyTransactionsFail = error => ({
    type: GET_GRAFANA_NON_KEY_TRANSACTIONS_FAIL,
    payload: error
})

export const getGrafanaNonKeyTransactionsSuccess = (response) => ({
    type: GET_GRAFANA_NON_KEY_TRANSACTIONS_SUCCESS,
    payload: response
})

export const postMarkNonKeyGrafanaTransactionAsBusinessTransaction = (data) => ({
    type: POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION,
    payload: data
})

export const postMarkNonKeyGrafanaTransactionAsBusinessTransactionFail = error => ({
    type: POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_FAIL,
    payload: error
})

export const postMarkNonKeyGrafanaTransactionAsBusinessTransactionSuccess = (response) => ({
    type: POST_MARK_GRAFANA_NON_KEY_TRANSACTION_AS_BUSINESS_TRANSACTION_SUCCESS,
    payload: response
})

